export const pricing = {
  regular: 'US$89',
  launch: 'US$19',
  savings: 'US$101',
  bonusValue: 'US$17',
  separateValue: 'US$120'
};
export const heroStats = [{
  value: '3',
  label: 'Libros'
}, {
  value: '2',
  label: 'Bonus premium'
}, {
  value: '375',
  label: 'Páginas'
}, {
  value: '100%',
  label: 'Digital'
}];
export const changeRows = [{
  situation: 'Son casi las doce.',
  now: 'El cuerpo quiere parar, pero tu cabeza sigue repasando pendientes y conversaciones.',
  with: 'Unos minutos de color y ritmo para bajar el volumen antes de dormir.'
}, {
  situation: '“No sé qué me pasa.”',
  now: 'Hay demasiado mezclado como para ponerlo fácilmente en palabras.',
  with: 'Le das forma con un color, una línea o un collage, sin tener que explicarlo todo.'
}, {
  situation: 'La página en blanco.',
  now: '“No sé qué hacer.” “Me va a quedar mal.” Y terminas sin empezar.',
  with: 'La consigna ya está preparada. Abres una página y empiezas por ahí.'
}];
export const changeSteps = [{
  title: 'Elige',
  text: 'lo que necesitas hoy'
}, {
  title: 'Crea',
  text: 'con la consigna y los materiales que tengas'
}, {
  title: 'Observa',
  text: 'sin juzgar el resultado'
}];
export const changeNeeds = ['Calmar', 'Expresar', 'Comprender', 'Fortalecer', 'Soltar', 'Avanzar'];
export const books = [{
  label: 'Libro 1',
  title: 'Calma y Expresión',
  description: 'Para bajar el ritmo y empezar a dar forma a lo que sientes.',
  includes: ['Color', 'Collage', 'Escritura creativa', 'Mapas visuales', 'Expresión emocional']
}, {
  label: 'Libro 2',
  title: 'Comprender y Fortalecer',
  description: 'Para explorar necesidades, límites, recursos, autoestima y autoconocimiento.',
  includes: ['Mapas', 'Brújulas', 'Fortalezas', 'Límites', 'Identidad', 'Reflexión visual']
}, {
  label: 'Libro 3',
  title: 'Soltar, Transformar y Avanzar',
  description: 'El volumen más artístico de la colección.',
  includes: ['Acuarela', 'Pintura', 'Mandalas', 'Color por números', 'Collage', 'Mixed media', 'Patrones y texturas']
}];
export const personalUses = ['desconectarte un momento de la pantalla', 'expresar algo difícil de poner en palabras', 'hacer algo con las manos', 'crear sin presión artística', 'dedicarte unos minutos'];
export const professionalUses = ['actividades visuales ya preparadas', 'recursos para sesiones individuales o grupales', 'alternativas cuando hablar no es suficiente', 'ideas listas sin diseñar cada actividad desde cero', 'guía de facilitación incluida'];
export const offerBooks = ['Calma y Expresión', 'Comprender y Fortalecer', 'Soltar, Transformar y Avanzar'];
export const bonuses = [{
  label: 'Bonus 1',
  title: '50 Cartas para Explorar tus Emociones',
  coverKey: 'bonus1Cover' as const,
  text: '50 cartas creativas para elegir una experiencia cuando no sabes por dónde empezar.'
}, {
  label: 'Bonus 2',
  title: 'Guía de Aplicación y Facilitación',
  coverKey: 'bonus2Cover' as const,
  text: 'Una guía práctica para elegir, presentar y acompañar experiencias creativas, especialmente útil para profesionales.'
}];
export const valueBreakdown = [{
  label: 'Biblioteca Pausa Propia',
  value: "US$89"
}, {
  label: 'Bonus 1',
  value: 'US$17'
}, {
  label: 'Bonus 2',
  value: 'US$17'
}];